import { Vehicle, VehicleFuelType } from '@api/index';

export const isElectricVehicle = (vehicle: Vehicle): boolean => vehicle.fuelType === VehicleFuelType.ELECTRIC;

export const separateVehiclesByType = (vehicles: Vehicle[]) => ({
    electric: vehicles.filter(isElectricVehicle),
    fuel: vehicles.filter((v) => !isElectricVehicle(v)),
});
